// extracted by mini-css-extract-plugin
export default {"name":"styles_name__drtUt"};